// import React from 'react';
import ChatBox from '../components/ChatBox';

const ChatPage = () => {
  return (
    <div>
      <ChatBox />
    </div>
  );
};

export default ChatPage;